"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentExport = exports.utils = void 0;
const utils_1 = __importDefault(require("./src/utils"));
exports.utils = utils_1.default;
const documentExport_1 = __importDefault(require("./src/documentExport"));
exports.documentExport = documentExport_1.default;
